import Splide from '@splidejs/splide';
import Grid from '@splidejs/splide-extension-grid';


const slider_elements = document.querySelectorAll('.splide');

slider_elements.length && slider_elements.forEach(slider => {
    const options = JSON.parse(slider.dataset.options);

    new Splide(`#${slider.id}`, options).mount({Grid});

    let pagination = slider.querySelector(".splide__pagination");
    if (slider.querySelector('.indicators')) {

        slider.querySelector('.indicators').innerHTML = '';

        slider.querySelector('.indicators').appendChild(pagination);
    }
});



// WEBPACK FOOTER //
// ./scripts/modules/splide.js